import styled from 'styled-components';
import colors from '../../../../constants/colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
`;

export const StyledSelect = styled.div`
  width: 62%;
  position: relative;

  .react-select-container {
    .react-select__indicators {
      display: none;
    }

    .react-select__control {
      border: none;
      min-height: auto;

      &--is-focused,
      &--menu-is-open {
        border: none;
        outline: none;
        box-shadow: none;
      }

      &--is-focused {
        outline: 2px solid ${colors.main.blue};
        outline-offset: 2px;
        border-radius: 2px;
      }
    }

    .react-select__menu {
      box-shadow: none;
      border-radius: 2px;
      border: 1px solid ${colors.main.dividers};
    }

    .react-select__option {
      cursor: pointer;
      color: ${colors.main.black};
      font-weight: 400;
      letter-spacing: 0.02em;

      &--is-focused {
        color: ${colors.main.white};
        background: ${colors.main.lightBlue};
      }

      &--is-selected {
        color: ${colors.main.white};
        background: ${colors.main.black} !important;
      }
    }

    .react-select__single-value,
    .react-select__input {
      color: ${colors.main.black};
    }

    .react-select__value-container {
      justify-content: flex-end;
      padding: 0;
    }

    .react-select__placeholder {
      color: ${colors.main.placeholdersForInput};
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0.02em;
      position: static;
      top: initial;
      transform: none;
    }

    .react-select__single-value {
      padding-right: 1px;

      & + div {
        margin-right: -1px;
      }
    }
  }
`;

export const NativeSelectContainer = styled.div`
  text-align: right;
`;

export const StyledNativeSelect = styled.select`
  width: 100%;
  min-width: 1px;
  text-align: right;
  border: none;
  outline: none;
  font-weight: 300;
  appearance: none;
  background: transparent;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
